import React from 'react';
import ENUMS from '../../enums/index';
import IntroducedCafesDetails from './modals/introducedCafesDetails';
import * as introducedCafesActions from '../../redux/introducedCafes/actions';
import { connect } from 'react-redux';
import { enumHelper } from '../../utils';
import generateClassName from '../../utils/generateClassName';
class IntroducedCafesTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sortype: 'desc',
      introducedCafesDetailsOpen: false,
      selectedIntroducedCafeId: null,
      sortedColumn: ''
    };
  }
  renderStatus = status => {
    switch (ENUMS.BANK_STATUS.list.filter(enum_status => enum_status.value === status)[0].value) {
      case 'PENDING':
        return 'badge-warning';
      case 'ERROR':
        return 'badge-danger';
      case 'TRANSFERRING' | 'CANCEL_BY_CUSTOMER' | 'TIMEOUT':
        return 'badge-info';
      case 'PAID':
        return 'badge-success';
      default:
        break;
    }
  };
  sortTable = query => {
    this.props.sortTable(query);
    this.setState({ sortedColumn: query });
  };
  closeIntroducedCafesModal = () => {
    this.props
      .fetchAllIntroducedCafes(
        `pageNumber=${this.props.pageNumber}&pageSize=${this.props.pageSize}&sort=createdAt-desc`
      )
      .then(() => {
        this.setState(() => ({
          introducedCafesDetailsOpen: false
        }));
      });
  };

  displayIntroducedCafesDetailsModal = id => {
    let { introducedCafesList = [] } = this.props;
    let selectedIntroducedCafeId = introducedCafesList.filter(introducedCafe => introducedCafe.id == id)[0]
      .id;
    this.setState({ introducedCafesDetailsOpen: true, selectedIntroducedCafeId });
  };
  render() {
    let { pageNumber, pageSize, introducedCafesList, sortType } = this.props;
    return (
      <>
        <div className='table-responsive-lg'>
          <table className="table table-hover table-light table-striped">
            <thead className="thead-dark">
            <tr>
              <th className="text-center">{locales('tables.row')}</th>
              <th onClick={() => this.sortTable('createdAt')} className="text-center pointer">
                <i
                  name="createdAt"
                  className={generateClassName('createdAt', this.state.sortedColumn, sortType)}
                />
                {locales('tables.financial.transaction.createdDate')}
              </th>
              <th onClick={() => this.sortTable('cafeName')} className="text-center pointer">
                <i
                  name="cafeName"
                  className={generateClassName('cafeName', this.state.sortedColumn, sortType)}
                />
                {locales('fields.cafe.name')}
              </th>
              <th onClick={() => this.sortTable('cafeCityName')} className="text-center pointer">
                <i
                  name="cafeCityName"
                  className={generateClassName('cafeCityName', this.state.sortedColumn, sortType)}
                />
                {locales('tables.cityName')}
              </th>
              <th onClick={() => this.sortTable('introducerName')} className="text-center pointer">
                <i
                  name="introducerName"
                  className={generateClassName('introducerName', this.state.sortedColumn, sortType)}
                />
                {locales('messages.introducerName')}
              </th>
              {/* <th onClick={() => this.sortTable('cafeAddress')} className="text-center pointer">
                <i
                  name="cafeAddress"
                  className={generateClassName('cafeAddress', this.state.sortedColumn, sortType)}
                />
                {locales('messages.address')}
              </th> */}
              {/* <th onClick={() => this.sortTable('cafePhoneNumber')} className="text-center pointer">
                <i
                  name="cafePhoneNumber"
                  className={generateClassName('cafePhoneNumber', this.state.sortedColumn, sortType)}
                />
                {locales('tables.cafePhoneNumber')}
              </th> */}
              <th onClick={() => this.sortTable('introducerMobileNumber')} className="text-center pointer">
                <i
                  name="introducerMobileNumber"
                  className={generateClassName('introducerMobileNumber', this.state.sortedColumn, sortType)}
                />
                {locales('fields.mobileNumber')}
              </th>

              <th onClick={() => this.sortTable('isPaidRegistrationFee')} className="text-center pointer">
                <i
                  name="registrationFee"
                  className={generateClassName('isPaidRegistrationFee', this.state.sortedColumn, sortType)}
                />
                {locales('messages.registrationFee')}
              </th>

              <th onClick={() => this.sortTable('isPaidRegistrationFee')} className="text-center pointer">
                <i
                  name="isPaidRegistrationFee"
                  className={generateClassName('isPaidRegistrationFee', this.state.sortedColumn, sortType)}
                />
                {locales('labels.isPaidRegistrationFee')}
              </th>

              <th onClick={() => this.sortTable('isCafeOwner')} className="text-center pointer">
                <i
                  name="isCafeOwner"
                  className={generateClassName('isCafeOwner', this.state.sortedColumn, sortType)}
                />
                {locales('labels.CafeOwner')}
              </th>

              <th onClick={() => this.sortTable('status')} className="text-center pointer">
                <i name="status" className={generateClassName('status', this.state.sortedColumn, sortType)} />
                {locales('tables.status')}
              </th>
              <th className="text-center"></th>
            </tr>
            </thead>
            <tbody>
            {introducedCafesList.length ? (
              introducedCafesList.map((introducedCafe, index) => (
                <tr key={introducedCafe.id}>
                  <td className="text-center">{(pageNumber - 1) * pageSize + index + 1}</td>
                  <td className="text-center">{introducedCafe.createdAt}</td>
                  <td className="text-center">{introducedCafe.cafeName}</td>
                  <td className="text-center">{introducedCafe.cafeCityName}</td>
                  <td className="text-center">{introducedCafe.introducerName}</td>
                  {/* <td className="text-center">{introducedCafe.cafeAddress}</td> */}
                  {/* <td className="text-center">{introducedCafe.cafePhoneNumber}</td> */}
                  <td className="text-center">{introducedCafe.introducerMobileNumber}</td>
                  <td className="text-center">{introducedCafe.registrationFee?.toLocaleString()}</td>
                  <td className="text-center">
                    <i
                      className={
                        introducedCafe.isPaidRegistrationFee
                          ? 'fal fa-vote-yea text-success font-weight-bold px-2 font-xlarge'
                          : 'fal fa-vote-nay text-danger font-weight-bold px-2 font-xlarge'
                      }
                    />
                  </td>
                  <td className="text-center">
                    <i
                      className={
                        introducedCafe.isCafeOwner
                          ? 'fal fa-vote-yea text-success font-weight-bold px-2 font-xlarge'
                          : 'fal fa-vote-nay text-danger font-weight-bold px-2 font-xlarge'
                      }
                    />
                  </td>
                  <td
                    className={`text-center ${ENUMS.INTRODUCED_CAFE_STATUS.list.filter(
                      item => item.value === introducedCafe.status,
                    )[0].color
                    }`}
                  >
                    {enumHelper.convertEnumValueToTitle(
                      ENUMS.INTRODUCED_CAFE_STATUS.list,
                      introducedCafe.status,
                    )}
                  </td>
                  <td title={locales('titles.moreDetails')}>
                    <i
                      onClick={() => this.displayIntroducedCafesDetailsModal(introducedCafe.id)}
                      className="text-center far fa-info-circle pointer"
                    />
                  </td>
                </tr>
              ))
            ) : (
              <tr className="col-12 text-center">
                <td className="alert alert-info" colSpan={12}>
                  {locales('alerts.noRecord')}
                </td>
              </tr>
            )}
            </tbody>
          </table>
        </div>
        {this.state.introducedCafesDetailsOpen && (
          <IntroducedCafesDetails
            isOpen={this.state.introducedCafesDetailsOpen}
            introducedCafeId={this.state.selectedIntroducedCafeId}
            closeModal={this.closeIntroducedCafesModal}
          />
        )}
      </>
    );
  }
}
const mapDispatchToProps = dispatch => {
  return {
    fetchAllIntroducedCafes: query => dispatch(introducedCafesActions.fetchAllIntroducedCafes(query))
  };
};
const mapStateToProps = state => {
  return {
    introducedCafesList: state.introducedCafesReducer.introducedCafesList || []
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IntroducedCafesTable);
